import React from 'react';
import { Button, Link, Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';

const getCopy = copyFor('emailLogin');

interface Props {
  disabled: boolean;
  loading: boolean;
}

export const Footer = ({ disabled, loading }: Props) => (
  <div>
    <Button
      fullWidth
      disabled={disabled}
      type="submit"
      loading={loading}
      margin={{ bottom: '16px' }}
      mode="primary"
    >
      {getCopy('buttons.signIn')}
    </Button>
    <Text textAlign="center">
      <Link to={routes.passwordlessAuth}>
        {getCopy('links.forgotPassword')}
      </Link>
    </Text>
  </div>
);
